import * as React from 'react';
import CircleLoader from "react-spinners/ClipLoader";
import './LoadingIndicator.scss';

export const LoadingIndicator: React.FC = () => {
    return (
        <div data-testid='loading-indicator' className='edl-loading-indicator-container'>
            <CircleLoader className='edl-loading-indicator' />
        </div>
    );
};
